/*
 * O convite no store (`canela-invites`), espelho do InviteResource do PHP.
 */
import Model from 'flarum/common/Model';
export default class Invite extends Model {
  code() {
    return Model.attribute('code').call(this);
  }
  url() {
    return Model.attribute('url').call(this);
  }
  maxRedemptions() {
    return Model.attribute('maxRedemptions').call(this);
  }
  redemptionCount() {
    return Model.attribute('redemptionCount').call(this);
  }
  expiresAt() {
    return Model.attribute('expiresAt', Model.transformDate).call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }

  /** Ainda vale: dentro da validade e com usos sobrando. */
  usable() {
    return Model.attribute('usable').call(this);
  }
}
flarum.reg.add('ramon-canela', 'forum/gaps/backend/Invite', Invite);